import {Injectable} from '@angular/core';
import {Client} from 'elasticsearch-browser';
import {from, Observable} from 'rxjs';
import {AsaxPropertiesService} from 'asax-properties';


export interface ElasticDSLQuery {
  readonly index: any;
  readonly body?: ElasticDSLBodyQuery;
}

export interface ElasticSort {
  readonly _source?: string[];
  readonly from?: number;
  readonly size?: number;
  readonly sort?: any;
  readonly query?: any;
  readonly aggregations?: any;
}

export interface ElasticDSLBodyQuery {
  readonly _source?: string[];
  readonly from?: number;
  readonly size?: number;
  readonly sort?: any;
  readonly query?: any;
  readonly aggregations?: any;
}

@Injectable({providedIn: 'root'})
export class AsaxElasticService {
  private readonly client: Client;

  constructor(private readonly asaxPropertiesService: AsaxPropertiesService) {
    const {elasticsearchUrl} = asaxPropertiesService.getProperties();
    this.client = new Client({host: elasticsearchUrl});
  }

  searchByQuery(elasticDSLQuery: ElasticDSLQuery): Observable<any> {
    return from(this.client.search(elasticDSLQuery));
  }

  countByQuery(elasticDSLQuery: ElasticDSLQuery): Observable<any> {
    return from(this.client.count(elasticDSLQuery));
  }
}
